"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var Subject_1 = require("rxjs/Subject");
var search_filter_decorator_service_1 = require("../../../../shared/services/api/search-filter-decorator.service");
var bulk_picker_search_filter_context_1 = require("../../model/bulk-picker-search-filter-context");
var KeywordFilterComponent = /** @class */ (function () {
    function KeywordFilterComponent(messageService, searchFilterProviderService, ngZone) {
        this.messageService = messageService;
        this.searchFilterProviderService = searchFilterProviderService;
        this.ngZone = ngZone;
        this.filter = new core_1.EventEmitter();
        this.searchQuery = '';
        this.placeHolder = '';
        this._destroy$ = new Subject_1.Subject();
    }
    KeywordFilterComponent.prototype.ngOnInit = function () {
        var _this_1 = this;
        this._buttonConfig = this.dialogData.buttonConfig;
        this.messageService.getMessage('ejustice_search_by')
            .takeUntil(this._destroy$)
            .subscribe(function (message) {
            var keywords = _this_1.searchKeywordMetaFields.map(function (metaField) { return metaField.getDisplayNameMultilingual().getValue(_this_1.currentLanguageId); }).join(', ');
            _this_1.placeHolder = message + " " + keywords;
        });
    };
    KeywordFilterComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    KeywordFilterComponent.prototype.doSearch = function ($event) {
        if ($event.key !== 'Enter') {
            clearTimeout(this._timeout);
            var _this_2 = this;
            this._timeout = this.ngZone.runOutsideAngular(function () { return window.setTimeout(function () {
                var validKeywords = _this_2.searchQuery.match(/[^ ]{3,}/g);
                if (validKeywords && validKeywords.length) {
                    _this_2.buildAndEmitTheFilter(validKeywords);
                }
            }, 1000); });
        }
        else {
            if ($event.key === 'Enter') {
                var validKeywords = this.searchQuery.match(/[^ ]{3,}/g);
                if (validKeywords && validKeywords.length) {
                    this.buildAndEmitTheFilter(validKeywords);
                }
            }
        }
    };
    KeywordFilterComponent.prototype.buildAndEmitTheFilter = function (keywords) {
        var _this_1 = this;
        var _a;
        var fields = this.searchKeywordMetaFields.map(function (metaField) { return metaField.getSystemName(); });
        var filter = { '$and': [] };
        var keywordFilter = [];
        keywords.forEach(function (keyword) {
            fields.forEach(function (fieldSystemName) {
                var _a;
                keywordFilter.push((_a = {},
                    _a[fieldSystemName] = {
                        '$startswith': keyword
                    },
                    _a));
            });
        });
        filter.$and.push({ '$or': keywordFilter });
        if (this._buttonConfig.searchFilter.lookupFieldValue) {
            filter = {
                '$and': [
                    filter,
                    (_a = {},
                        _a[this._buttonConfig.searchFilter.lookupFieldSystemName] = this._buttonConfig.searchFilter.lookupFieldValue,
                        _a)
                ]
            };
        }
        if (this.searchFilterProviderService) {
            this.searchFilterProviderService.decorate(filter, new bulk_picker_search_filter_context_1.BulkPickerSearchFilterContext(this.dialogData.categoryId, this.dialogData.subEntityFieldId, this.dialogData.entity, this.dialogData.buttonConfig, this.dialogData.buttonId))
                .take(1)
                .takeUntil(this._destroy$)
                .subscribe(function (decoratedFilter) {
                return _this_1.filter.emit(decoratedFilter);
            });
        }
        else {
            this.filter.emit(filter);
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], KeywordFilterComponent.prototype, "searchKeywordMetaFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], KeywordFilterComponent.prototype, "dialogData", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], KeywordFilterComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], KeywordFilterComponent.prototype, "idPrefix", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], KeywordFilterComponent.prototype, "filter", void 0);
    KeywordFilterComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-keyword-filter',
            template: require('./keyword-filter.component.html'),
            styles: [require('./keyword-filter.component.css')]
        }),
        __param(1, core_1.Optional()),
        __metadata("design:paramtypes", [idm_ng_controls_1.MessageService,
            search_filter_decorator_service_1.SearchFilterDecoratorService,
            core_1.NgZone])
    ], KeywordFilterComponent);
    return KeywordFilterComponent;
}());
exports.KeywordFilterComponent = KeywordFilterComponent;
//# sourceMappingURL=keyword-filter.component.js.map